import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { forkJoin, Subscription } from 'rxjs';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { InstitutionType } from '@app/models/institution';
import { Country } from '@app/models/country';
import { CountryService } from '@app/services/shared/country.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { SortService } from '../sorting/SortService';
import { FileService } from '@app/services/files/file.service';
import { DatePipe } from '@angular/common';
interface Sieblings {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
}

interface Ancestor {
  id: number;
  shortName: string;
}

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

export enum Institutiontype {
  'BRÖDRALOGE' = '4',
  'REBECKALOGE' = '13',
  'BRÖDRALÄGER' = '5',
  'REBECKALÄGER' = '16',
  'BRÖDRAFÖRENING' = '7',
  'REBECKAFÖRENING' = '15',
  'STORLOGEN' = '21',
  'BLIVANDE_MEDLEM' = '12',
  'EGL' = '9',
  'SGL' = '20',
  'F1' = '23',
  'EL' = '10'
}

@Component({
  selector: 'app-institutions',
  templateUrl: './institutions.component.html',
  styleUrls: ['./institutions.component.css']
})

export class InstitutionsComponent implements OnInit, OnDestroy {
  @ViewChild('instnumber') instnumber: ElementRef;
  userpermissionlevel;
  userdomain;
  admininstitutionid;
  isMobile;
  institutions: LodgeAndCamp[] = [];
  disable = false;
  id: number;
  action: string;
  countries: Country[] = [];
  membercount: number;
  institutiontypes: InstitutionType[] = [];
  institutiontypename;
  minmaxyear = { minYear: '1800', maxYear: new Date().getFullYear() + 10 };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?089]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  viewmode = false;
  searchmeetingcalendarview = false;
  addmeetingview = false;
  subscriptions: Subscription[] = [];
  sieblingslist: Sieblings[] = [];
  ancestorslist: Ancestor[] = [];
  institutiondata: LodgeAndCamp;
  imagewidth;
  imageheight;
  imageToShow: any = null;
  result;
  form;
  

  membershipitems: MenuItem[];
  meetingcalendar;
  roleid;
  selectedrole;
  connectstring;
  can_edit_memfee;
  can_edit_institution;
  can_edit_member_signs;
  can_edit_member_offices;
  can_add_member_to_institution;
  can_insert_member_to_orden;
  fileData: File = null;
  updated: boolean = false;
  
  constructor(
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageService,
    private institutionService: InstitutionsService,
    private permissionsService: PermissionsService,
    private snackBarService: SnackbarService,
    private confirmationService: ConfirmationService,
    private countryService: CountryService,
    private fileService: FileService,
    private route: ActivatedRoute,
    private router: Router) {
      this.permissionsService.selectedrole.subscribe(x => {
        if(x)
        this.ngOnInit();
      });
  }

  handlePresence() {
    this.router.navigateByUrl('/narvarohantering');
  }

  checkNumber() {
    const checknumber = {
      institutionTypeId: Number(this.form.get('institutionTypeId').value),
      institutionNumber: Number(this.form.get('institutionNumber').value)
    };


    this.institutionService.checkInstitutionNumber(checknumber).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Institutionsnummer finns redan' });
        this.form.patchValue({ institutionNumber: '' });
        (this.instnumber.nativeElement as HTMLInputElement).focus();
      }
    });
  }

  async setPermissions(institutionid: number) {
    
    if (institutionid) {
      let can_edit_memfee_observable = this.permissionsService.hasPermissionForInstitution('EDIT_MEMFEE', institutionid);
      let can_edit_institution_observable = this.permissionsService.hasPermissionForInstitution('EDIT_INSTITUTION', institutionid);
      let can_edit_member_signs_observable = this.permissionsService.hasPermissionForInstitution('EDIT_MEMBER_SIGNS', institutionid);
      let can_edit_member_offices_observable = this.permissionsService.hasPermissionForInstitution('EDIT_MEMBER_OFFICES', institutionid);
      let can_add_member_to_institution = this.permissionsService.hasPermissionForInstitution('ADD_MEMBER_MEMBERSHIPS', institutionid);
      let can_insert_member_to_orden = this.permissionsService.hasPermissionForInstitution('INSERT_MEMBER', institutionid);
      this.subscriptions.push(forkJoin([
        can_edit_memfee_observable,
        can_edit_institution_observable,
        can_edit_member_signs_observable,
        can_edit_member_offices_observable,
        can_add_member_to_institution,
        can_insert_member_to_orden
      ]).subscribe(response => {
        if (response) {
        this.can_edit_memfee = response[0];
        this.can_edit_institution = response[1];
        this.can_edit_member_signs = response[2];
        this.can_edit_member_offices = response[3];
        this.can_add_member_to_institution = response[4];
        this.can_insert_member_to_orden = response[5];
      
        this.setItems();
        }
      }));
    }
  }

  ngOnInit() {

    this.form = this.fb.group({
      id: [null], // number
      shortName: [''],
      institutionTypeId: [null, Validators.required], // number
      institutionNumber: [null],
      name: ['', Validators.required],
      parentInstitutionId: [null],
      organizationNumber: [''],
      visitingAddress: this.fb.group({
        id: [null],
        street: [''],
        city: [''],
        country: ['']
      }),
      paymentAddress: this.fb.group({
        id: [null],
        careOf: [''],
        street: [''],
        zipCode: [''],
        city: [''],
        country: ['']
      }),
      email: [''],
      phone: [''],
      swish: [''],
      phoneMobile: [''],
      webSite: [''],
      startDate: [null, Validators.required], // Date
      endDate: [null], // Date
      bankAccount1: [''],
      bankAccount2: [''],
      installationInterval: [''],
      meetingInterval: [''],
      seat: ['']
    });
    
   
    this.activatedRoute.paramMap.subscribe(paramMap => {
  
    
      this.form.patchValue({ id: paramMap.get('id') });
      this.id = +paramMap.get('id');
      
     this.setPermissions(this.id);
    
      this.permissionsService.hasPermissionForInstitution('ADD_MEMBER_MEMBERSHIPS', this.id).subscribe(x => {
        if(x) {
          this.can_add_member_to_institution = x;
           this.updateInstitution();
        }
      });
      this.form.patchValue({ endDate: null });
      if (this.id) {
        this.ancestorslist = [];
        this.getInstitutionChildren(this.id);
        this.getAncestors(this.id);
        this.form.disable();
        this.setMemFee(this.id);
        let websiteurl = this.form.get('webSite').value;
        if (websiteurl) {
          websiteurl = websiteurl.replace('www.oddfellow.se/', '');
          websiteurl = websiteurl.replace('-', '');
          this.form.patchValue({ webSite: websiteurl });
        }
        this.permissionsService.setInstitutionAccess();
        if (this.selectedrole) {
          this.subscriptions.push(this.institutionService.getInstitutionNameInfoAsync(this.id).subscribe(data => {
            this.membercount = data.membershipCount;
          }));
        }
        //this.countries = this.countryService.getCountryList();
        this.countryService.countries$.subscribe(x => {
          if(x) {
            this.countries = x;
          }
        })
        this.getImageFromService(this.id);
      }
    });

    this.permissionsService.selectedrole.subscribe(x => {
      if (x) {
        this.selectedrole = x;
        this.roleid = x.roleId;
        this.userpermissionlevel = x.userPermissionLevel;
        this.userdomain = x.userDomain;
        if (this.userpermissionlevel === 'IN' || this.userpermissionlevel === 'SY') {
          this.admininstitutionid = x.institution.id;
          this.permissionsService.admininstitutionid = this.admininstitutionid;
        }
        this.permissionsService.institutionid = Number(this.route.snapshot.params.id);
        this.permissionsService.setInstitutionAccess();
        this.permissionsService.admininstitutionid = x.institution.id;
       // this.setItems();
        this.getInstitutionTypes();
        this.getAllInstitutions();
       // this.updateInstitution();
      }
    });
    const self = this;
    this.action = this.route.queryParams['value'].action;
console.log('this.action:', this.action);

  }

  getInstitutionChildren(id) {
    this.institutionService.GetInstitutionChildren(id).subscribe(data => {
      this.sieblingslist = data;
    });
  }
  setMemFee(id) {
    this.permissionsService.hasPermissionForInstitution('EDIT_MEMFEE', id).subscribe(p => {
      this.isMobile = window.navigator.userAgent.toLowerCase().includes('mobi');
      this.permissionsService.institutionid = this.id;
      this.searchmeetingcalendarview = false;
      this.addmeetingview = false;
      this.form.disable();
      this.updateInstitution();
    });
  }
  addOffice() {
    this.router.navigate(['uppdrag'], { queryParams: { id: this.id, type: 'institution' }, queryParamsHandling: "merge" });
  }

  addSign() {
    this.router.navigate(['grader'], { queryParams: { id: this.id, type: 'institution' }, queryParamsHandling: "merge" });
  }

  tinyMatrix() {
    this.router.navigateByUrl('/lillamatrikeln_report/' + this.id);
  }

  memberMatrix() {
    this.router.navigateByUrl('/membermatrix/' + this.id);
  }

  updateInstitution() {
    this.institutionService.getInstitutionByIdAsync(this.id).subscribe(async i => {
      if (i) {
    
        this.form.patchValue(i as any);
        const formattedStartDate = this.datePipe.transform(i.startDate, 'yyyy-MM-dd') ?? '';
        this.form.get('startDate')?.setValue(formattedStartDate);

        const formattedEndDate = this.datePipe.transform(i.endDate, 'yyyy-MM-dd') ?? '';
        this.form.get('endDate')?.setValue(formattedEndDate === '9999-12-31' ? '' : formattedEndDate);

        const institutiontypename = this.institutiontypes.find(y => y.id === i.institutionTypeId);
        this.institutiontypename = institutiontypename?.name;
        
      
        await this.setPermissions(this.id);
        this.setItems();
        
        this.subscriptions.push(this.institutionService.getInstitutionNameInfoAsync(this.id).subscribe(data => {
          this.membercount = data.membershipCount;
         
        }));
      }
    });
  }

  viewMemberFees() {
    this.router.navigateByUrl('/medlemsavgifter/' + this.id);
  }

  setItems() {
   
    const institutiontype = +this.form.value.institutionTypeId;

    
    if (this.can_add_member_to_institution) {
      switch (institutiontype) {
        case +Institutiontype.BRÖDRALÄGER: {
          this.connectstring = 'Koppla medlem till läger';
          break;
        }
        case +Institutiontype.REBECKALÄGER: {
          this.connectstring = 'Koppla medlem till läger';
          break;
        }
        case +Institutiontype.BRÖDRAFÖRENING: {
          this.connectstring = 'Koppla medlem till förening';
          break;
        }
        case +Institutiontype.REBECKAFÖRENING: {
          this.connectstring = 'Koppla medlem till förening';
          break;
        }
        case +Institutiontype.STORLOGEN: {
          this.connectstring = 'Koppla medlem till storlogen';
          break;
        }
        case +Institutiontype.EGL: {
          this.connectstring = 'Koppla medlem till EGL1';
          break;
        }
        case +Institutiontype.SGL: {
          this.connectstring = 'Koppla medlem till SGL';
          break;
        }
        case +Institutiontype.F1: {
          this.connectstring = 'Koppla medlem till F1 - Utvalda vänner';
          break;
        }
        
      }}
 
    this.membershipitems = [
      {
        label: 'Medlemskap',
        visible: this.action !== 'new' && this.can_add_member_to_institution,
        items: [{
          label: 'Ny medlem',
          icon: 'fa fa-plus',
          command: () => this.addMember(),
          visible:  (institutiontype !== +Institutiontype.STORLOGEN && institutiontype !== +Institutiontype.EGL && institutiontype !== +Institutiontype.SGL && institutiontype !== +Institutiontype.F1) && (this.can_insert_member_to_orden && (institutiontype === +Institutiontype.BRÖDRALOGE || institutiontype === +Institutiontype.REBECKALOGE || institutiontype === +Institutiontype.BLIVANDE_MEDLEM || institutiontype === +Institutiontype.EGL || institutiontype === +Institutiontype.SGL || institutiontype === +Institutiontype.F1 || institutiontype === +Institutiontype.EL))
        }, {
          label: this.connectstring,
          icon: 'fa fa-link',
          command: () => this.addMemberToCamp(),
          visible: (this.connectstring != undefined && institutiontype !== +Institutiontype.STORLOGEN) && this.can_add_member_to_institution && (institutiontype !== +Institutiontype.EGL && institutiontype !== +Institutiontype.SGL && institutiontype !== +Institutiontype.BRÖDRALOGE && institutiontype !== +Institutiontype.REBECKALOGE && institutiontype !== +Institutiontype.BLIVANDE_MEDLEM && institutiontype !== +Institutiontype.EL)
        
        }, {
          label: this.connectstring,
          icon: 'fa fa-link',
          command: () => this.addMemberToStorlogen(),
          visible: ((institutiontype === +Institutiontype.STORLOGEN || institutiontype === +Institutiontype.EGL || institutiontype === +Institutiontype.SGL || institutiontype === +Institutiontype.F1) && this.selectedrole?.userDomain === 'GENERAL') && this.can_add_member_to_institution && (institutiontype !== +Institutiontype.BRÖDRALOGE && institutiontype !== +Institutiontype.REBECKALOGE)
        }]
      }
    ]
    this.updated = true;
  }

  addMemberToStorlogen() {
    this.router.navigateByUrl('/nymedlemlager/' + this.id);
  }

  addMemberToCamp() {
    this.router.navigateByUrl('/nymedlemlager/' + this.id);
  }

  searchMeeting() {
    this.permissionsService.setMemberAccess();
    this.searchMeetingCalendar();
  }

  searchMeetingCalendar() {
    this.router.navigateByUrl('search_meeting/' + this.form.value.id + '/' + this.roleid);
  }

  addMeeting() {
    this.addmeetingview = true;
    this.institutiondata = {
      id: this.form.get('id').value,
      shortName: this.form.get('shortName').value,
      name: this.form.get('name').value
    };
  }

  closeAddMeeting(evt) {
    this.addmeetingview = false;
  }

  closeSearchMeeting(evt) {
    this.searchmeetingcalendarview = false;
  }

  getAncestors(institutionid: number) {
    if (institutionid) {
      this.subscriptions.push(this.institutionService.GetInstitutionParent(institutionid).subscribe(data => {
        if (data) {
          this.ancestorslist = [];
          this.ancestorslist.push(data);
          if (data[0]?.shortName !== 'SL1') {
            this.getAncestors(data[0]?.id);
          } else {
            this.reverseObjectArrayList();
          }
        }
      }));
    }
  }

  reverseObjectArrayList() {
    if (this.ancestorslist.length > 1) {
      const alist: Ancestor[] = [];
      for (let i = this.ancestorslist.length - 1; i >= 0; i--) {
        alist.push(this.ancestorslist[i]);
      }
      this.ancestorslist = alist;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  disableForm(dis) {
    this.disable = !dis;
    dis ? this.form.disable() : this.form.enable();
  }

  getInstitutionTypes() {
    this.subscriptions.push(this.institutionService.getInstitutionTypes().subscribe(data => {
      this.institutiontypes = data;
    }));
  }

  saveForm() {
    if (this.form.get('id').value) {
      this.form.markAsPristine();
      this.disable = true;
      this.disableForm(true);
      this.subscriptions.push(this.institutionService.updateInstitution(this.form.value).subscribe(data => {
        this.router.navigate(['/institutions/id/', this.form.get('id').value]);
        this.snackBarService.openSnackBar('Institutionen uppdaterad.', null);
      }));
    } else {
      this.subscriptions.push(this.institutionService.addInstitution(this.form.value).subscribe(data => {
        this.snackBarService.openSnackBar('Institutionen sparad.', null);
        this.router.navigate(['/institutions/id/', data]);
      }));
    }
  }

  onSubmit() { }

  cancel() {
    if (this.form.dirty) {
       this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avbryta utan att spara ändringarna?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
          if (this.action === 'new') {
            this.form.reset();
            this.router.navigate(['']);
          } else {
            this.router.navigate(['/institutions/id/', this.form.get('id').value]);
            this.ngOnInit();
            this.disableForm(true);
          }
      },
      reject: () => {
      }
    });
    } else {
      if (this.action === 'new') {
        this.router.navigate(['']);
      } else {
        this.disableForm(true);
      }
    }
  }

  get shortName() {
    return this.form.get('shortName');
  }

  get institutionTypeId() {
    return this.form.get('institutionTypeId');
  }

  get institutionNumber() {
    return this.form.get('institutionNumber');
  }

  get name() {
    return this.form.get('name');
  }

  get organizationNumber() {
    return this.form.get('organizationNumber');
  }

  get startDate() {
    return this.form.get('startDate');
  }

  get endDate() {
    return this.form.get('endDate');
  }

  viewMembers() {
    // tslint:disable-next-line:max-line-length
    const institution = { institutionName: this.form.get('name').value, institutionNumber: this.form.get('institutionNumber').value, institutionTypeId: this.form.get('institutionTypeId').value };
    this.router.navigate(['/searchmember/institution/'], { queryParams: institution, queryParamsHandling: 'merge' });
  }

  addMember() {
    this.router.navigateByUrl('/intrade/' + this.id);
  }

  getAllInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutions = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutions.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
    });
  }





  fileChangeEvent(event: any): void {
    this.fileData = <File>event.target.files[0];
    const formData = new FormData();
    formData.append('uploadedFile', this.fileData);
    formData.append('originatingId', this.form.get('id').value);
    if (this.fileData.name.substring(this.fileData.name.indexOf('.'), this.fileData.name.length) === '.jpg') {
      this.fileService.UploadInstitutionEmblem(formData).subscribe(response => {
        if (response) {
          this.snackBarService.openSnackBar('Sigill inlagt', null);

          //this.router.navigateByUrl('/memberform/id/' + this.memberid);
          //this.router.navigate(['/institutions/id/', this.form.get('id').value]);
          this.getImageFromService(this.id);
          this.router.navigate(['/institutions/id/', this.id]);
        }
      }, error => {
        this.snackBarService.openSnackBar('Det är endast bilder med ändelsen .jpg som är tillåtna!', null);
      });
    } else {
      this.snackBarService.openSnackBar('Det är endast bilder med ändelsen .jpg som är tillåtna!', null);
    }
  }

  getImageFromService(id: number) {
    if (this.action !== 'new') {
      this.imageToShow = null;

      this.fileService.GetEmblemImage(id).subscribe(data => {
        this.createImageFromBlob(data);
      }, error => {
        this.imageToShow = null;
      });
    }
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageToShow = reader.result;
      if (this.imageToShow) {
        this.getSize(this.imageToShow);
      }
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  getSize(imgdata) {
    const image = document.createElement('img');
    const self = this;
    image.addEventListener('load', function () {
      self.imagewidth = image.width;
      self.imageheight = image.height;
    });
    image.src = imgdata;
  }

  confirmDialog(): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera sigillet?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: async () => {
          const res: Response = await fetch('../../../assets/sigillsaknas.jpg');
        const blob: Blob = await res.blob();
        const file = new File([blob], this.form.get('id').value + '.jpg', { type: 'image/jpeg' });
        const formData = new FormData();
        formData.append('uploadedFile', file);
        formData.append('originatingId', this.form.get('id').value);
        this.fileService.UploadInstitutionEmblem(formData).subscribe(response => {
          if (response) {
            this.snackBarService.openSnackBar('Sigill raderat', null);
            this.getImageFromService(this.id);
          }
        });
      },
      reject: () => {
      }
    });
  }

  deleteEmblemImage() {

    this.confirmDialog();
  }
}
